export function getSharePageUrl(defaultUrl: string = "https://aiml4pi.org"): string {
  if (typeof window !== "undefined") {
    return window.location.href;
  }

  return process.env.NEXT_PUBLIC_SITE_URL || defaultUrl;
}
